import { getTokenByAuthRole, getLoginRouteByAuthRole } from "@/utils/auth";

/** 无需登录即可访问的路由 name */
const PUBLIC_ROUTE_NAMES = new Set([
  "login",
  "deliveryLogin",
  "riderLogin",
  "signin",
  "riderSignin",
]);

export function setupRouterGuards(router) {
  router.beforeEach((to) => {
    if (PUBLIC_ROUTE_NAMES.has(to.name)) {
      return true;
    }

    if (to.meta?.requiresAuth === false) {
      return true;
    }

    if (!to.meta?.requiresAuth) {
      return true;
    }

    const authRole = to.meta.authRole || "manage";
    if (getTokenByAuthRole(authRole)) {
      return true;
    }

    return {
      name: getLoginRouteByAuthRole(authRole),
      replace: true,
      query: { redirect: to.fullPath },
    };
  });
}
